/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { onMounted, onBeforeMount } from 'vue';
import { on, off } from '../utils/dom.mjs';
import { i as isString_1 } from '../_chunks/dep-7f2f03b4.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../utils/easing.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-a6022780.mjs';

function useKeyboard(radioGroupRef, setInnerValue) {
  var checkRadioInGroup = function checkRadioInGroup(e) {
    if (/enter/i.test(e.key) || /enter/i.test(e.code)) {
      var inputNode = e.target.querySelector("input");
      var data = inputNode.dataset;
      if (inputNode.checked && data.allowUncheck) {
        setInnerValue(void 0, {
          e: e
        });
      } else {
        var value = !isNaN(Number(data.value)) ? Number(data.value) : data.value;
        value = isString_1(value) && {
          "true": true,
          "false": false
        }[value] || value;
        value = isString_1(value) && value[0] === "'" ? value.replace(/'/g, "") : value;
        setInnerValue(value, {
          e: e
        });
      }
    }
  };
  onMounted(function () {
    on(radioGroupRef.value, "keydown", checkRadioInGroup);
  });
  onBeforeMount(function () {
    off(radioGroupRef.value, "keydown", checkRadioInGroup);
  });
}

export { useKeyboard as default };
//# sourceMappingURL=useKeyboard.mjs.map
